import { createStore, action, thunk } from 'easy-peasy';

const store = createStore({
	// Auth state
	authorized: false,
	user: null,

	// UI state
	toast: {
		visible: false,
		message: '',
		type: 'info' // 'info', 'success', 'error', 'warning'
	},

	// Auth actions
	setAuthorized: action((state, payload) => {
		state.authorized = true;
		state.user = payload || null;
	}),

	setUnauthorized: action((state) => {
		state.authorized = false;
		state.user = null;
	}),

	updateUser: action((state, payload) => {
		state.user = { ...state.user, ...payload };
	}),

	// Toast actions
	showToast: action((state, payload) => {
		state.toast = {
			visible: true,
			message: payload.message,
			type: payload.type || 'info'
		};
	}),

	hideToast: action((state) => {
		state.toast = {
			visible: false,
			message: '',
			type: 'info'
		};
	}),

	// Thunk for showing toast with auto-hide
	displayToast: thunk(async (actions, payload) => {
		actions.showToast(payload);

		// Auto-hide after 5 seconds
		setTimeout(() => {
			actions.hideToast();
		}, payload.duration || 5000);
	})
});

export default store;
